export const listUserInvitsQuery = /* GraphQL */ `
  query organizationsAndMembers(
    $userID: ID!
    $filter: ModelOrganizationMemberFilterInput
    $status: ModelStringKeyConditionInput
  ) {
    organizationMemberbyUser(
      userID: $userID
      filter: $filter
      status: $status
      limit: 1000
    ) {
      items {
        id
        role
        status
        userID
        organizationID
        projectID
        invitationDetails
        type
        email
        createdAt
        updatedAt
      }
    }
  }
`
